import { Injectable, computed, inject, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WINDOW } from '@ng-web-apis/common';

import { isIos, isPWA } from '../util';
import { InstallOnIosInstructionsComponent } from './install-on-ios-instructions.component';

@Injectable()
export class PwaAppInstallerService {
  private dialog = inject(MatDialog);
  private window = inject(WINDOW, { optional: true });

  private promptEvent = signal<BeforeInstallPromptEvent | undefined>(undefined);
  private isAppInstalled = signal(false);

  showCustomButton = computed(() => {
    return !!this.promptEvent() && !this.isAppInstalled();
  });

  showIosCustomButton = isIos() && !isPWA();

  constructor() {
    if (!this.window) {
      return;
    }

    this.window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      this.promptEvent.set(event);
    });

    this.window.addEventListener('appinstalled', () => {
      this.isAppInstalled.set(true);
    });
  }

  promptInstallPwa() {
    this.promptEvent()?.prompt();
  }

  promptInstallPwaOnIos() {
    this.dialog.open(InstallOnIosInstructionsComponent);
  }
}
